import { observable, computedFrom, BindingEngine, bindable, bindingMode, autoinject, containerless } from 'aurelia-framework';
import * as condition from './condition';
export class SearchCriteria {

    constructor() {
        SearchCriteria.loadOperations();
        this.operations = SearchCriteria._operations;
    }

    @bindable() fields: any;
    @bindable() add;
    @bindable() remove;
    @bindable({ defaultBindingMode: bindingMode.twoWay }) condition: any;

    _remove() {
        this.remove(this.condition);
    }

    fieldType = condition.ConditionFieldType;

    static _operations: Array<condition.ConditionOperation>;
    operations: Array<condition.ConditionOperation>;
    static loadOperations() {
        if (!SearchCriteria._operations) {
            SearchCriteria._operations = [];
            SearchCriteria._operations.push(<condition.ConditionOperation>{
                operator: "contains",
                input: true,
                supportedTypes: [condition.ConditionFieldType.string]
            });
            SearchCriteria._operations.push(<condition.ConditionOperation>{ operator: "starts with", input: true, supportedTypes: [condition.ConditionFieldType.string] });
            SearchCriteria._operations.push(<condition.ConditionOperation>{ operator: "equals", input: true });
            //this.operations.push(<condition.ConditionOperation>{ operator: "is one of", input: true });
            SearchCriteria._operations.push(<condition.ConditionOperation>{ operator: "is true", supportedTypes: [condition.ConditionFieldType.bool], input: false });
            SearchCriteria._operations.push(<condition.ConditionOperation>{ operator: "is false", supportedTypes: [condition.ConditionFieldType.bool], input: false });
            SearchCriteria._operations.push(<condition.ConditionOperation>{ operator: "greater than", supportedTypes: [condition.ConditionFieldType.number, condition.ConditionFieldType.date], input: true});
            SearchCriteria._operations.push(<condition.ConditionOperation>{ operator: "less than", supportedTypes: [condition.ConditionFieldType.number, condition.ConditionFieldType.date], input: true});
            SearchCriteria._operations.push(<condition.ConditionOperation>{ operator: "is empty", input: false });
            SearchCriteria._operations.push(<condition.ConditionOperation>{ operator: "is not empty", input: false });
        }
    }

    @computedFrom("operations.length", "condition.field")
    get filteredOperations(): Array<condition.ConditionOperation> {

        if (!this.condition.field) {
            return [];
        }

        return this.operations.filter((operation) => {
            return !operation.supportedTypes || operation.supportedTypes.indexOf(this.condition.field.type) > -1;
        });
    }


}